<template>
    <div>
        <form style="margin-top: 20%">
            <div class="form-group" style="padding-left: 25%; padding-right: 25%;">
                <input v-model="nome" type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nome da Categoria">
            </div>
            <button @click="gravar" type="submit" class="btn btn-success" style="margin-right: 10px">Gravar</button>
            <button @click="voltar" type="submit" class="btn btn-danger">Cancelar</button>
        </form>
    </div>
</template>
<script>
import firebase from 'firebase';
// var database = firebase.database();

export default {
    name: 'Nova Categorias',
	data() {
		return {
            nome: '',
            editar: false,
            idCategoria: null,
            url: ''
		}
	},
	created() {
        this.$route.params.tipo === 'produto' ? this.url = 'categorias2/' : this.url = 'categorias/'
        if(this.$route.params.id) {
            this.editar = true;
            this.idCategoria = this.$route.params.id;
            firebase.database().ref('categorias/' + this.idCategoria).once('value').then((snapshot) => {
                this.nome = (snapshot.val()).nome;
            });
        }
	},
	methods: {
        async gravar() {
            if(!this.editar) {
                var bd = firebase.database().ref(this.url);
                let proxId = 0
    
                // percorre a tabela para ver qual o ultimo ID utilizado
                // o AWAIT irá parar a execução do programa aqui até que esta função termine de ser executada
                await bd.on('child_added', (data) => {
                let ultimoId = parseInt(data.key);
                    proxId = ultimoId > proxId ? ultimoId : proxId
                });
                proxId++
    
                // grava um novo cliente com o proximo ID disponivel
                await firebase.database().ref(this.url + proxId).set({
                    nome: this.nome
                });
                this.voltar();
            } else {
                await firebase.database().ref(this.url + this.idCategoria ).update({
                    nome: this.nome,
                });
                this.voltar();
            }
        },
        voltar() {
            this.$router.go(-1)
        }
	}
}
</script>
